<template>
  <div>
    <LeaseTopComponent
      v-bind:popinfoid="$route.query.popinfoid"
      v-bind:tsid="$route.query.tsid"
      v-bind:otoken="$route.query.otoken"
      v-bind:x_cls_app_version="$route.query.x_cls_app_version"
      v-bind:x_cls_os="$route.query.x_cls_os"
      v-bind:x_cls_os_version="$route.query.x_cls_os_version"
    >
    </LeaseTopComponent>
  </div>
</template>

<script>
import LeaseTopComponent from '@/components/v3/LeaseTopComponent.vue'
import modal from '@/assets/v3/modal'

export default {
  components: {
    LeaseTopComponent
  },
  methods: {
    openErrorModal (message) {
      modal.alert(message)
    }
  },
  async mounted () {
  }
}
</script>
